import axios from 'axios'

export async function loadTranslations(modelClass, modelId, fields = []) {
  const { data } = await axios.get('/backend/translations', {
    params: {
      model_class: modelClass,
      model_id: modelId,
      fields: fields.join(','),
    },
  })
  return data
}

export async function saveTranslations(modelClass, modelId, clientId, textTranslations, mediaFiles) {
  const { data } = await axios.post('/backend/translations', {
    model_class: modelClass,
    model_id: modelId,
    client_id: clientId,
    text_translations: textTranslations,
    media_files: mediaFiles,
  })
  return data
}

export async function aiTranslateText(text, sourceIso, targetIso) {
  const { data } = await axios.post('/backend/app_ai_translations/store', {
    text,
    sourceIso,
    targetIso,
    useCache: false,
  })
  return data
}

export async function aiTranslateImage(formData) {
  const { data } = await axios.post('/backend/app_ai_translations/translate-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}
